<template>
  <v-main>
    <v-container fluid>
      <v-row>
        <v-col md="12">
          <v-card elevation="6" rounded="xxl">
            <v-card-title class="d-flex flex-wrap align-center">
              <h3 class="font-weight-bold" v-text="'Gift Order'"></h3>
              <v-btn
                class="mx-2 mb-2"
                fab
                x-small
                color="primary"
                to="/gift-orders/update-status?update_status=1"
              >
                <v-icon dark>mdi-eye</v-icon>
              </v-btn>

              <v-spacer></v-spacer>

              <!-- Delhivery Wallet Status Badge -->
              <div class="delhivery-wallet-badge d-flex align-center" :class="getWalletBadgeClass()">
                <img
                  src="https://www.delhivery.com/favicon.ico"
                  alt="Delhivery"
                  class="delhivery-logo mr-2"
                  @error="$event.target.style.display='none'"
                />
                <div class="wallet-info d-flex align-center">
                  <span class="wallet-label">DELHIVERY WALLET</span>
                  <v-chip
                    small
                    class="ml-3 wallet-status-chip"
                    :color="getWalletChipColor()"
                    text-color="white"
                    v-if="!walletLoading"
                  >
                    <v-icon left x-small>{{ getWalletStatusIcon() }}</v-icon>
                    {{ getWalletStatusText() }}
                  </v-chip>
                  <v-progress-circular
                    v-else
                    indeterminate
                    size="18"
                    width="2"
                    color="primary"
                    class="ml-3"
                  ></v-progress-circular>
                </div>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      v-bind="attrs"
                      v-on="on"
                      icon
                      x-small
                      class="ml-3 action-btn"
                      @click="fetchWalletBalance"
                      :loading="walletLoading"
                    >
                      <v-icon small>mdi-refresh</v-icon>
                    </v-btn>
                  </template>
                  <span>Refresh Status</span>
                </v-tooltip>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      v-bind="attrs"
                      v-on="on"
                      icon
                      x-small
                      class="ml-1 action-btn"
                      :href="walletBalance.portal_url || 'https://one.delhivery.com'"
                      target="_blank"
                    >
                      <v-icon small>mdi-open-in-new</v-icon>
                    </v-btn>
                  </template>
                  <span>Open Delhivery Portal</span>
                </v-tooltip>
              </div>
            </v-card-title>
            <v-card-text>
              <v-row>
                <!-- Row 1 -->
                <v-col cols="12" sm="4">
                  <v-text-field
                    solo
                    rounded
                    v-model="filter.search_keyword"
                    label="Search by name, phone..."
                    color="#e60040"
                    prepend-inner-icon="mdi-magnify"
                    clearable
                    @click:clear="
                      (filter.search_keyword = null), (page = 1), getData()
                    "
                    @keydown.enter="(page = 1), getData()"
                  >
                  </v-text-field>
                </v-col>
                <v-col cols="12" sm="4">
                  <v-autocomplete
                    solo
                    rounded
                    v-model="filter.status"
                    :items="statusItem"
                    item-text="text"
                    item-value="value"
                    clearable
                    :menu-props="{ maxHeight: 350 }"
                    @click:clear="(filter.status = null), (page = 1), getData()"
                    label="Order Status"
                    @input="getData"
                    prepend-inner-icon="mdi-list-status"
                  ></v-autocomplete>
                </v-col>
                <!-- Row 2 -->
                <v-col cols="12" sm="4">
                  <v-autocomplete
                    solo
                    rounded
                    v-model="filter.gift_catalog_id"
                    :items="giftCatalogs"
                    item-text="text"
                    item-value="value"
                    clearable
                    @click:clear="(filter.gift_catalog_id = null), (page = 1), getData()"
                    label="Gift Catalog"
                    @input="getData"
                    prepend-inner-icon="mdi-gift"
                  ></v-autocomplete>
                </v-col>
                <!-- Start date -->
                <v-col cols="12" sm="4">
                  <v-menu
                    v-model="start_menu"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        solo
                        rounded
                        v-model="filter.start_date"
                        label="Start Date"
                        append-icon="mdi-calendar"
                        readonly
                        v-bind="attrs"
                        v-on="on"
                        clearable
                        @click:clear="
                          () => {
                            filter.start_date = null;
                            getData();
                          }
                        "
                        hide-details
                        :error-messages="errors.start_date"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="filter.start_date"
                      @input="
                        getData();
                        start_menu = false;
                      "
                    ></v-date-picker>
                  </v-menu>
                </v-col>
                <!-- /Start date -->
                <!-- End date -->
                <v-col cols="12" sm="4">
                  <v-menu
                    v-model="end_menu"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        solo
                        rounded
                        v-model="filter.end_date"
                        label="End Date"
                        append-icon="mdi-calendar"
                        readonly
                        v-bind="attrs"
                        v-on="on"
                        clearable
                        @click:clear="
                          () => {
                            filter.end_date = null;
                            getData();
                          }
                        "
                        hide-details
                        :error-messages="errors.end_date"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="filter.end_date"
                      @input="
                        getData();
                        end_menu = false;
                      "
                    ></v-date-picker>
                  </v-menu>
                </v-col>
                <!-- /End date -->
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
      <v-row>
        <v-col md="12">
          <v-card elevation="6" rounded="xxl">
            <v-card-title v-if="place_orders.length != 0">
              <v-spacer></v-spacer>
              <v-btn
                rounded
                large
                class="primary"
                @click="generateExcel()"
                v-if="isDeletePage() != true"
              >
                <span v-if="isExcelloading"> Generating Excel... </span>
                <span v-else>Generate Excel</span>
              </v-btn>
            </v-card-title>
            <v-card-text>
              <section v-if="isLoading" style="height: 285px">
                <v-progress-linear
                  indeterminate
                  color="primary"
                ></v-progress-linear>
              </section>
              <v-simple-table
                v-else
                class="striped-table"
              >
                <template v-slot:default>
                  <thead>
                    <tr>
                      <!-- <th>
                        <input
                          type="checkbox"
                          @change="selectAll()"
                          v-model="is_select_all"
                        />&nbsp; Sr. No.
                      </th> -->
                      <th class="text-left">Sr No</th>
                      <th class="text-left">Status</th>
                      <th class="text-left" style="min-width: none">user</th>
                      <th class="text-left" style="min-width: none">Gift</th>
                      <th class="text-left" style="min-width: none">Address</th>
                      <th class="text-left" style="min-width: none">Pincode</th>
                      <th class="text-left" style="min-width: none">Phone</th>
                      <th class="text-left" style="min-width: none">Date</th>
                      <th class="text-left" style="min-width: none">
                        Quantity
                      </th>
                      <th class="text-left" style="min-width: none">Remarks</th>
                      <th class="text-left" style="min-width: none">Status</th>
                      <th class="text-right action_th">Action</th>
                    </tr>
                  </thead>
                  <tbody v-if="place_orders.length != 0">
                    <tr
                      v-for="(gift_order, i) in place_orders"
                      :key="`gift_order_${i}`"
                      :class="{
                        'table-row-even': i % 2 === 0,
                        'table-row-odd': i % 2 !== 0,
                        'table-row-last': place_orders.length - 1 == i,
                      }"
                    >
                      <td style="min-width: 85px">
                        {{ i + 1 }}
                      </td>
                      <!-- <td>
                        <input
                          type="checkbox"
                          v-model="gift_order.is_selected"
                        />
                        &nbsp;{{ i + 1 }}
                      </td> -->
                      <td>
                        <v-tooltip bottom v-if="gift_order.is_active == 1">
                          <template v-slot:activator="{ on, attrs }">
                            <v-chip
                              v-bind="attrs"
                              v-on="on"
                              small
                              color="teal"
                              text-color="white"
                            >
                              <v-avatar left>
                                <v-icon size="15"
                                  >mdi-checkbox-marked-circle</v-icon
                                >
                              </v-avatar>
                              Active
                            </v-chip>
                          </template>
                          <span> Gift Orders is Active</span>
                        </v-tooltip>
                        <v-tooltip bottom v-if="gift_order.is_active == 0">
                          <template v-slot:activator="{ on, attrs }">
                            <v-chip
                              v-bind="attrs"
                              v-on="on"
                              small
                              color="red"
                              text-color="white"
                            >
                              <v-avatar left>
                                <v-icon size="15">mdi-close-circle</v-icon>
                              </v-avatar>
                              Inactive
                            </v-chip>
                          </template>
                          <span>Gift Order is InActive</span>
                        </v-tooltip>
                      </td>
                      <td>
                        {{ gift_order.user ? gift_order.user.user_name : "" }}
                      </td>
                      <td>
                        {{
                          gift_order.gift_catalog
                            ? gift_order.gift_catalog.name
                            : ""
                        }}
                      </td>
                      <td>
                        {{
                          gift_order.address_line1 +
                            "," +
                            gift_order.address_line2 || ""
                        }}
                      </td>
                      <td>
                        {{ gift_order.pin_code || "" }}
                      </td>
                      <td>
                        {{ gift_order.user ? gift_order.user.phone : "" }}
                      </td>
                      <td>
                        {{ formatDate(gift_order.created_at) }}
                      </td>

                      <td>
                        {{ gift_order.quantity || "" }}
                      </td>
                      <td>
                        {{ gift_order.remarks || "" }}
                      </td>
                      <td>
                        <v-btn
                          rounded
                          :color="getBtnColor(gift_order.status)"
                          text-color="white"
                          style="text-transform: none !important"
                        >
                          {{ getStatusText(gift_order.status) }}
                        </v-btn>
                      </td>
                      <td class="text-right" style="white-space: nowrap;">
                        <div class="d-inline-flex align-center">
                          <!-- Show View Shipment if delivery exists and has waybill -->
                          <v-tooltip bottom v-if="hasDelivery(gift_order) && gift_order.delivery && gift_order.delivery.waybill">
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn
                                v-bind="attrs"
                                v-on="on"
                                fab
                                x-small
                                color="info"
                                class="mr-1"
                                @click="openViewShipmentDialog(gift_order)"
                              >
                                <v-icon dark size="18">mdi-eye</v-icon>
                              </v-btn>
                            </template>
                            <span>View Shipment Details</span>
                          </v-tooltip>

                          <!-- Show Download Shipping Label if delivery exists and has waybill and not cancelled -->
                          <v-tooltip bottom v-if="hasDelivery(gift_order) && gift_order.delivery && gift_order.delivery.waybill && gift_order.status !== 6">
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn
                                v-bind="attrs"
                                v-on="on"
                                fab
                                x-small
                                color="deep-purple"
                                class="mr-1"
                                @click="downloadShippingLabel(gift_order)"
                                :loading="downloadingLabel === gift_order.id"
                              >
                                <v-icon color="white" size="18">mdi-file-pdf-box</v-icon>
                              </v-btn>
                            </template>
                            <span>Download Shipping Label</span>
                          </v-tooltip>

                          <!-- Show Cancel Shipment if delivery exists and is not cancelled -->
                          <v-tooltip bottom v-if="hasDelivery(gift_order) && canCancelShipment(gift_order)">
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn
                                v-bind="attrs"
                                v-on="on"
                                fab
                                x-small
                                color="error"
                                @click="confirmCancelShipment(gift_order)"
                                :loading="cancellingShipment === gift_order.id"
                              >
                                <v-icon dark size="18">mdi-cancel</v-icon>
                              </v-btn>
                            </template>
                            <span>Cancel Shipment</span>
                          </v-tooltip>

                          <!-- Show Create Shipment only if no delivery exists AND order is not delivered/rejected/cancelled -->
                          <v-tooltip bottom v-if="!hasDelivery(gift_order) && gift_order.status !== 5 && gift_order.status !== 6 && gift_order.status !== 7 && gift_order.status !== 8">
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn
                                v-bind="attrs"
                                v-on="on"
                                fab
                                x-small
                                color="success"
                                @click="navigateToCreateShipment(gift_order)"
                              >
                                <v-icon dark size="18">mdi-truck-delivery</v-icon>
                              </v-btn>
                            </template>
                            <span>Create Shipment</span>
                          </v-tooltip>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                  <tbody v-else>
                    <tr>
                      <td colspan="12" class="text-center">No data found</td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
              <v-pagination rounded v-model="page" :length="paginationLength">
              </v-pagination>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
      <!-- Clear Success Dialog Box -->
      <v-dialog v-model="is_deleted_gift_order" width="600">
        <v-card rounded="xxl">
          <v-container>
            <v-row align="center">
              <v-col sm="3" align="center">
                <v-icon
                  large
                  style="color: green; font-size: 90px; width: 200px !important"
                >
                  mdi-delete-empty
                </v-icon>
              </v-col>
              <v-col sm="9" align="center">
                <v-card-text>
                  <v-row>
                    <v-col>
                      <h1 style="color: green">Hurray!</h1>
                      <br />
                      <h3>Gift Orders deleted successfully.</h3>
                      <br />
                      <v-btn
                        color="success"
                        @click="is_deleted_gift_order = false"
                      >
                        OK
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-col>
            </v-row>
          </v-container>
        </v-card>
      </v-dialog>
      
      
      
      <!-- Shipment Tracking Dialog -->
      <v-dialog v-model="viewShipmentDialog" max-width="1000px" persistent>
        <v-card rounded="xxl">
          <v-card-title>
            <v-icon left color="primary">mdi-truck-delivery</v-icon>
            <span class="headline">Shipment Tracking</span>
            <v-chip
              v-if="liveTrackingActive"
              x-small
              color="red"
              text-color="white"
              class="ml-2 live-badge"
            >
              <v-icon left x-small>mdi-access-point</v-icon>
              LIVE
            </v-chip>
            <v-spacer></v-spacer>
            <v-btn icon @click="closeViewShipmentDialog">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card-title>
          <v-card-text>
            <v-container>
              <!-- Loading State -->
              <v-row v-if="loadingTrackingData">
                <v-col cols="12" class="text-center">
                  <v-progress-circular indeterminate color="primary"></v-progress-circular>
                  <p class="mt-3">Loading tracking information...</p>
                </v-col>
              </v-row>

              <!-- Tracking Information -->
              <v-row v-else-if="trackingData">
                <!-- Customer & Pickup Details Side by Side -->
                <v-col cols="12" md="6">
                  <v-card elevation="2" rounded="lg" class="details-card">
                    <v-card-title class="py-3">
                      <v-icon color="primary" class="mr-2">mdi-account</v-icon>
                      <span class="font-weight-medium">Customer Details</span>
                    </v-card-title>
                    <v-card-text>
                      <div class="detail-item">
                        <span class="detail-label">Name</span>
                        <span class="detail-value">{{ viewShipmentForm.customer_name || 'N/A' }}</span>
                      </div>
                      <div class="detail-item">
                        <span class="detail-label">Phone</span>
                        <span class="detail-value">{{ viewShipmentForm.customer_phone || 'N/A' }}</span>
                      </div>
                      <div class="detail-item">
                        <span class="detail-label">Address</span>
                        <span class="detail-value">
                          {{ formatAddress(viewShipmentForm.customer_address, viewShipmentForm.customer_city, viewShipmentForm.customer_state, viewShipmentForm.customer_pincode, viewShipmentForm.customer_country) }}
                        </span>
                      </div>
                    </v-card-text>
                  </v-card>
                </v-col>

                <v-col cols="12" md="6">
                  <v-card elevation="2" rounded="lg" class="details-card">
                    <v-card-title class="py-3">
                      <v-icon color="success" class="mr-2">mdi-store</v-icon>
                      <span class="font-weight-medium">Pickup / Vendor Details</span>
                    </v-card-title>
                    <v-card-text>
                      <div class="detail-item">
                        <span class="detail-label">Vendor Name</span>
                        <span class="detail-value">{{ viewShipmentForm.vendor_name || 'N/A' }}</span>
                      </div>
                      <div class="detail-item">
                        <span class="detail-label">Vendor Phone</span>
                        <span class="detail-value">{{ viewShipmentForm.vendor_phone || 'N/A' }}</span>
                      </div>
                      <div class="detail-item">
                        <span class="detail-label">Pickup Address</span>
                        <span class="detail-value">
                          {{ formatAddress(viewShipmentForm.pickup_address, viewShipmentForm.pickup_city, viewShipmentForm.pickup_state, viewShipmentForm.pickup_pincode, viewShipmentForm.pickup_country) }}
                        </span>
                      </div>
                    </v-card-text>
                  </v-card>
                </v-col>

                <!-- Return Details & Package Details -->
                <v-col cols="12">
                  <v-expansion-panels v-model="deliveryDetailsPanel" multiple flat>
                    <!-- Return Details (if different from pickup) -->
                    <v-expansion-panel v-if="hasReturnInfo">
                      <v-expansion-panel-header class="py-2">
                        <div class="d-flex align-center">
                          <v-icon color="warning" class="mr-2">mdi-keyboard-return</v-icon>
                          <span class="font-weight-medium">Return Details</span>
                        </div>
                      </v-expansion-panel-header>
                      <v-expansion-panel-content>
                        <v-row dense>
                          <v-col cols="12" md="6">
                            <div class="detail-item">
                              <span class="detail-label">Return Phone</span>
                              <span class="detail-value">{{ viewShipmentForm.return_phone || 'N/A' }}</span>
                            </div>
                          </v-col>
                          <v-col cols="12">
                            <div class="detail-item">
                              <span class="detail-label">Return Address</span>
                              <span class="detail-value">
                                {{ formatAddress(viewShipmentForm.return_address, viewShipmentForm.return_city, viewShipmentForm.return_state, viewShipmentForm.return_pincode, viewShipmentForm.return_country) }}
                              </span>
                            </div>
                          </v-col>
                        </v-row>
                      </v-expansion-panel-content>
                    </v-expansion-panel>

                    <!-- Package Details -->
                    <v-expansion-panel>
                      <v-expansion-panel-header class="py-2">
                        <div class="d-flex align-center">
                          <v-icon color="info" class="mr-2">mdi-gift</v-icon>
                          <span class="font-weight-medium">Package Details</span>
                        </div>
                      </v-expansion-panel-header>
                      <v-expansion-panel-content>
                        <v-row dense>
                          <v-col cols="12">
                            <div class="detail-item waybill-highlight">
                              <span class="detail-label">Waybill Number</span>
                              <span class="detail-value font-weight-bold primary--text">{{ trackingData.waybill || viewShipmentForm.waybill || 'N/A' }}</span>
                            </div>
                          </v-col>
                          <v-col cols="12" md="6">
                            <div class="detail-item">
                              <span class="detail-label">Gift Item</span>
                              <span class="detail-value">{{ selectedGiftOrder && selectedGiftOrder.gift_catalog ? selectedGiftOrder.gift_catalog.name : 'N/A' }}</span>
                            </div>
                          </v-col>
                          <v-col cols="12" md="6">
                            <div class="detail-item">
                              <span class="detail-label">Order Number</span>
                              <span class="detail-value">{{ viewShipmentForm.order_number || 'N/A' }}</span>
                            </div>
                          </v-col>
                          <v-col cols="12" md="4">
                            <div class="detail-item">
                              <span class="detail-label">Quantity</span>
                              <span class="detail-value">{{ viewShipmentForm.quantity || 1 }}</span>
                            </div>
                          </v-col>
                          <v-col cols="12" md="4">
                            <div class="detail-item">
                              <span class="detail-label">Total Amount</span>
                              <span class="detail-value">{{ viewShipmentForm.total_amount ? '₹' + viewShipmentForm.total_amount : 'N/A' }}</span>
                            </div>
                          </v-col>
                          <v-col cols="12" md="4" v-if="selectedGiftOrder && selectedGiftOrder.gift_catalog && selectedGiftOrder.gift_catalog.hsn_code">
                            <div class="detail-item">
                              <span class="detail-label">HSN Code</span>
                              <span class="detail-value">{{ selectedGiftOrder.gift_catalog.hsn_code }}</span>
                            </div>
                          </v-col>
                          <v-col cols="12" v-if="viewShipmentForm.final_delhivery_amount">
                            <div class="detail-item shipping-charge-highlight">
                              <span class="detail-label">Delhivery Shipping Charge</span>
                              <span class="detail-value font-weight-bold success--text">
                                ₹{{ parseFloat(viewShipmentForm.final_delhivery_amount).toFixed(2) }}
                                <v-tooltip bottom v-if="viewShipmentForm.delhivery_gross_amount">
                                  <template v-slot:activator="{ on, attrs }">
                                    <v-icon small class="ml-1" v-bind="attrs" v-on="on">mdi-information-outline</v-icon>
                                  </template>
                                  <div class="text-caption">
                                    <div>Gross: ₹{{ viewShipmentForm.delhivery_gross_amount }}</div>
                                    <div v-if="viewShipmentForm.delhivery_freight_charge">Freight: ₹{{ viewShipmentForm.delhivery_freight_charge }}</div>
                                    <div v-if="viewShipmentForm.delhivery_tax_data">Tax (CGST+SGST): ₹{{ ((viewShipmentForm.delhivery_tax_data.CGST || 0) + (viewShipmentForm.delhivery_tax_data.SGST || 0)).toFixed(2) }}</div>
                                  </div>
                                </v-tooltip>
                              </span>
                            </div>
                          </v-col>
                          <v-col cols="12" v-if="selectedGiftOrder && selectedGiftOrder.gift_catalog && (selectedGiftOrder.gift_catalog.weight || selectedGiftOrder.gift_catalog.length)">
                            <div class="detail-item">
                              <span class="detail-label">Dimensions</span>
                              <span class="detail-value">
                                <span v-if="selectedGiftOrder.gift_catalog.length">L: {{ selectedGiftOrder.gift_catalog.length }}cm</span>
                                <span v-if="selectedGiftOrder.gift_catalog.width"> x W: {{ selectedGiftOrder.gift_catalog.width }}cm</span>
                                <span v-if="selectedGiftOrder.gift_catalog.height"> x H: {{ selectedGiftOrder.gift_catalog.height }}cm</span>
                                <span v-if="selectedGiftOrder.gift_catalog.weight"> | {{ selectedGiftOrder.gift_catalog.weight }}kg</span>
                              </span>
                            </div>
                          </v-col>
                          <v-col cols="12" v-if="viewShipmentForm.remarks">
                            <div class="detail-item">
                              <span class="detail-label">Remarks</span>
                              <span class="detail-value">{{ viewShipmentForm.remarks }}</span>
                            </div>
                          </v-col>
                        </v-row>
                      </v-expansion-panel-content>
                    </v-expansion-panel>
                  </v-expansion-panels>
                </v-col>

                <!-- Tracking Timeline -->
                <v-col cols="12">
                  <v-card elevation="2" rounded="lg">
                    <v-card-title class="pb-2">
                      <v-icon left color="primary">mdi-timeline</v-icon>
                      Tracking History
                    </v-card-title>
                    <v-card-text>
                      <div class="delhivery-timeline">
                        <div 
                          v-for="(event, index) in getTrackingHistory()"
                          :key="index"
                          class="delhivery-timeline-item"
                          :class="{ 
                            'completed': event.isCompleted,
                            'pending': !event.isCompleted
                          }"
                        >
                          <div class="timeline-icon-wrapper">
                            <div class="delhivery-icon-container">
                              <v-icon 
                                :color="event.isCompleted ? 'white' : '#9E9E9E'"
                                class="delhivery-icon"
                                size="18"
                              >
                                {{ event.icon }}
                              </v-icon>
                            </div>
                            <div 
                              v-if="index < getTrackingHistory().length - 1" 
                              class="delhivery-timeline-line"
                              :class="{ 
                                'completed-line': event.isCompleted,
                                'pending-line': !event.isCompleted
                              }"
                            ></div>
                          </div>
                          
                          <div class="delhivery-content">
                            <h4 class="delhivery-status" :class="{ 'completed-status': event.isCompleted }">
                              {{ event.status }}
                            </h4>
                            <div class="delhivery-meta">
                              <span v-if="event.isCompleted && event.date" class="delhivery-date">{{ formatTrackingDate(event.date) }}</span>
                              <span v-else-if="!event.isCompleted && event.remarks && event.remarks !== 'Pending'" class="delhivery-date text-grey">{{ event.remarks }}</span>
                              <p v-if="event.isCompleted && event.remarks" class="delhivery-description">{{ event.remarks }}</p>
                              <p v-if="event.isCompleted && event.location" class="delhivery-location">{{ event.location }}</p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </v-card-text>
                  </v-card>
                </v-col>

                <!-- Additional Information -->
                <v-col cols="12" v-if="trackingData.remarks">
                  <v-card elevation="2" rounded="lg">
                    <v-card-title class="pb-2">
                      <v-icon left color="primary">mdi-note-text</v-icon>
                      Additional Information
                    </v-card-title>
                    <v-card-text>
                      <p class="text-body-2 mb-0">{{ trackingData.remarks }}</p>
                    </v-card-text>
                  </v-card>
                </v-col>
              </v-row>

              <!-- Error State -->
              <v-row v-else-if="trackingError">
                <v-col cols="12" class="text-center">
                  <v-icon size="64" color="error">mdi-alert-circle</v-icon>
                  <h3 class="error--text mt-3">Unable to load tracking information</h3>
                  <p class="text-body-2 grey--text">{{ trackingError }}</p>
                  <v-btn color="primary" @click="refreshTrackingData">
                    <v-icon left>mdi-refresh</v-icon>
                    Retry
                  </v-btn>
                </v-col>
              </v-row>
              
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="primary"
              outlined
              @click="refreshTrackingData"
              :loading="loadingTrackingData"
            >
              <v-icon left>mdi-refresh</v-icon>
              Refresh
            </v-btn>
            <v-btn
              color="grey"
              text
              @click="closeViewShipmentDialog"
            >
              Close
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <!-- Cancel Shipment Confirmation Dialog -->
      <v-dialog v-model="cancelShipmentDialog" max-width="500px" persistent>
        <v-card rounded="xxl">
          <v-card-title class="text-h5">
            <v-icon left color="warning">mdi-cancel</v-icon>
            Cancel Shipment
          </v-card-title>
          <v-card-text>
            <p class="text-body-1 mb-3">
              Are you sure you want to cancel this shipment?
            </p>
            
            <v-card elevation="2" outlined class="mb-3">
              <v-card-text class="py-2">
                <div class="text-caption grey--text">Gift Order</div>
                <div class="text-body-2 font-weight-bold">
                  {{ selectedGiftOrderForCancel ? selectedGiftOrderForCancel.gift_catalog.name : '' }}
                </div>
                <div class="text-caption grey--text mt-1">Waybill</div>
                <div class="text-body-2">
                  {{ selectedGiftOrderForCancel ? selectedGiftOrderForCancel.delivery.waybill : '' }}
                </div>
              </v-card-text>
            </v-card>
            
            <v-alert
              type="warning"
              dense
              outlined
              class="text-body-2"
            >
              This action cannot be undone. The shipment will be cancelled with Delhivery.
            </v-alert>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              text
              @click="cancelShipmentDialog = false; selectedGiftOrderForCancel = null"
              :disabled="!!cancellingShipment"
            >
              Cancel
            </v-btn>
            <v-btn
              color="error"
              :loading="!!cancellingShipment"
              @click="cancelShipment"
            >
              <v-icon left>mdi-cancel</v-icon>
              Confirm Cancellation
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-container>
  </v-main>
</template>

<script>
import axios from "axios";
import moment from "moment";
export default {
  name: "GiftOrdersPage",
  data() {
    return {
      // Wallet balance data
      walletBalance: {
        balance: null,
        balance_display: null,
        status: 'unknown', // sufficient, insufficient, unknown, error
        status_color: 'grey', // green, red, grey
        is_sufficient: true,
        can_create_shipment: true,
        minimum_required: 500,
        currency: 'INR',
        portal_url: 'https://one.delhivery.com'
      },
      walletLoading: false,
      filter: {
        search_keyword: "",
        is_active: "",
        status: "",
        gift_catalog_id: "",
        start_date: null,
        end_date: null,
      },
      giftCatalogs: [],
      place_orders: [],
      statuses: [
        {
          id: 0,
          text: "Select Active Status",
          value: "",
        },
        { id: "ACTIVE", text: "ACTIVE", value: "1" },
        { id: "INACTIVE", text: "INACTIVE", value: "0" },
      ],
      statusItem: [
        { text: "All Status", value: "" },
        { text: "Pending", value: "0" },
        { text: "Order Placed", value: "1" },
        { text: "Pickup", value: "2" },
        { text: "In Transit", value: "3" },
        { text: "Out For Delivery", value: "4" },
        { text: "Delivered", value: "5" },
        { text: "Order Cancelled", value: "6" },
        { text: "Rejected", value: "7" },
        { text: "RTO", value: "8" },
      ],
      page: 1,
      serialNoStarting: 1,
      paginationLength: 0,
      count: 0,
      isLoading: false,
      isExcelloading: false,
      delete_gift_order: false,
      is_deleted_gift_order: false,
      is_select_all: false,
      isDeleteAll: false,
      start_menu: false,
      end_menu: false,
      viewShipmentDialog: false,
      isUpdatingShipment: false,
      isEditingShipment: false,
      selectedGiftOrder: null,
      selectedDelivery: null,
      originalShipmentData: null,
      // Tracking-related data
      trackingData: null,
      loadingTrackingData: false,
      trackingError: null,
      liveTrackingActive: false,
      // Cancel shipment related data
      cancelShipmentDialog: false,
      cancellingShipment: null,
      selectedGiftOrderForCancel: null,
      // Download shipping label related data
      downloadingLabel: null,
      // Delivery details expansion panel
      deliveryDetailsPanel: [0, 1], // Default open Return Details (if shown) and Package Details
      viewShipmentForm: {
        id: '',
        gift_order_id: '',
        gift_catalog_id: '',
        customer_id: '',
        vendor_id: '',
        order_number: '',
        seller_invoice: '',
        customer_name: '',
        customer_phone: '',
        customer_address: '',
        customer_city: '',
        customer_state: '',
        customer_pincode: '',
        customer_country: '',
        vendor_name: '',
        vendor_phone: '',
        pickup_address: '',
        pickup_city: '',
        pickup_state: '',
        pickup_pincode: '',
        pickup_country: '',
        return_phone: '',
        return_address: '',
        return_city: '',
        return_state: '',
        return_pincode: '',
        return_country: '',
        total_amount: '',
        quantity: '',
        waybill: '',
        remarks: '',
        is_active: true
      },
    };
  },
  computed: {
    hasReturnInfo() {
      if (!this.viewShipmentForm) return false;
      return this.viewShipmentForm.return_address ||
             this.viewShipmentForm.return_city ||
             this.viewShipmentForm.return_phone;
    }
  },
  watch: {
    page: "getData",
  },
  mounted() {
    this.getData();
    this.fetchWalletBalance();
    this.fetchGiftCatalogs();
  },
  methods: {
    async fetchWalletBalance() {
      try {
        this.walletLoading = true;
        const response = await axios.get('/delhivery/wallet-balance');

        if (response.data.success && response.data.data) {
          const data = response.data.data;
          this.walletBalance = {
            balance: data.balance,
            balance_display: data.balance_display,
            status: data.status || 'unknown',
            status_color: data.status_color || 'grey',
            is_sufficient: data.is_sufficient,
            can_create_shipment: data.can_create_shipment,
            minimum_required: data.minimum_required || 500,
            currency: data.currency || 'INR',
            portal_url: data.portal_url || 'https://one.delhivery.com'
          };
        }
      } catch (error) {
        console.error('Error fetching wallet balance:', error);
        // Set default values on error
        this.walletBalance = {
          balance: null,
          balance_display: null,
          status: 'error',
          status_color: 'grey',
          is_sufficient: null,
          can_create_shipment: null,
          minimum_required: 500,
          currency: 'INR',
          portal_url: 'https://one.delhivery.com'
        };
      } finally {
        this.walletLoading = false;
      }
    },
    // Wallet badge helper methods
    getWalletBadgeClass() {
      if (this.walletBalance.status === 'sufficient') return 'wallet-sufficient';
      if (this.walletBalance.status === 'insufficient') return 'wallet-low';
      return 'wallet-unknown';
    },
    getWalletIconColor() {
      if (this.walletBalance.status_color === 'green') return 'success';
      if (this.walletBalance.status_color === 'red') return 'error';
      return 'grey';
    },
    getWalletAmountClass() {
      if (this.walletBalance.status_color === 'green') return 'success--text';
      if (this.walletBalance.status_color === 'red') return 'error--text';
      return 'grey--text';
    },
    getWalletChipColor() {
      if (this.walletBalance.status_color === 'green') return 'success';
      if (this.walletBalance.status_color === 'red') return 'error';
      return 'grey';
    },
    getWalletStatusText() {
      if (this.walletBalance.status === 'sufficient') return 'Sufficient';
      if (this.walletBalance.status === 'insufficient') return 'Insufficient';
      return 'Unknown';
    },
    getWalletStatusIcon() {
      if (this.walletBalance.status === 'sufficient') return 'mdi-check-circle';
      if (this.walletBalance.status === 'insufficient') return 'mdi-alert-circle';
      return 'mdi-help-circle';
    },
    async fetchGiftCatalogs() {
      try {
        const response = await axios.get('gift_catalogs?all=1');
        const list = response.data.data || [];
        this.giftCatalogs = [
          { text: 'All Catalogs', value: '' },
          ...list.map(c => ({ text: c.name || c.description, value: c.id })),
        ];
      } catch (error) {
        console.error('Error fetching gift catalogs:', error);
      }
    },
    async getData() {
      this.isLoading = true;
      this.filter.search_keyword = this.filter.search_keyword || "";
      this.filter.is_active = this.filter.is_active != null ? this.filter.is_active : "";
      this.filter.status = this.filter.status != null ? this.filter.status : "";
      this.filter.gift_catalog_id = this.filter.gift_catalog_id || "";
      if (this.$route.query.user_id) {
        this.filter.user_id = this.decryptIt(this.$route.query.user_id);
      } else {
        this.filter.user_id = "";
      }
      let query =
        "page=" +
        this.page +
        "&rowsPerPage=" +
        this.rowsPerPage +
        "&is_active=" +
        this.filter.is_active +
        "&status=" +
        this.filter.status +
        "&user_id=" +
        this.filter.user_id +
        "&search_keyword=" +
        this.filter.search_keyword +
        "&gift_catalog_id=" +
        this.filter.gift_catalog_id +
        (this.filter.start_date ? "&start_date=" + this.filter.start_date : "") +
        (this.filter.end_date ? "&end_date=" + this.filter.end_date : "");
      await axios
        .get(`place_orders?${query}`)
        .then((response) => {
          this.place_orders = response.data.data;
          this.count = response.data.count;
          this.serialNoStarting = (this.page - 1) * this.rowsPerPage;
          this.paginationLength = Math.ceil(this.count / this.rowsPerPage);
          // Augment catalog dropdown with any catalogs found in orders
          const seen = new Set(this.giftCatalogs.filter(c => c.value !== '').map(c => c.value));
          (response.data.data || []).forEach(order => {
            if (order.gift_catalog && !seen.has(order.gift_catalog.id)) {
              seen.add(order.gift_catalog.id);
              this.giftCatalogs.push({ text: order.gift_catalog.name, value: order.gift_catalog.id });
            }
          });
        })
        .catch(function (error) {
          console.log(error);
          // window.location.href = "/auth/login";
        });
      this.isLoading = false;
    },
    getStatusText(status) {
      // 0=Pending, 1=Order Placed, 2=Pickup, 3=In Transit, 4=Out For Delivery, 5=Delivered, 6=Order Cancelled, 7=Rejected, 8=RTO
      switch (status) {
        case 0:
          return "Pending";
        case 1:
          return "Order Placed";
        case 2:
          return "Pickup";
        case 3:
          return "In Transit";
        case 4:
          return "Out For Delivery";
        case 5:
          return "Delivered";
        case 6:
          return "Order Cancelled";
        case 7:
          return "Rejected";
        case 8:
          return "RTO";
        default:
          return "Unknown";
      }
    },
    getBtnColor(status) {
      switch (status) {
        case 0:
          return "warning";
        case 1:
          return "blue";
        case 2:
          return "orange";
        case 3:
          return "info";
        case 4:
          return "light-blue";
        case 5:
          return "green";
        case 6:
          return "red";
        case 7:
          return "grey";
        case 8:
          return "deep-orange";
        default:
          return "blue-grey";
      }
    },

    // async Delete_this(id) {
    //   this.delete_gift_oder = true;
    //   await axios
    //     .post(`/place_orders/delete/${this.encryptIt(id)}`)
    //     .then(() => {
    //       this.delete_gift_order = false;
    //       this.is_deleted_gift_order = true;
    //       this.getData();
    //     })
    //     .catch(function (error) {
    //       console.log(error);
    //       // window.location.href = "/auth/login";
    //     });
    // },
    // selectAll() {
    //   console.log(this.is_select_all);
    //   this.place_orders.forEach((gift_order) => {
    //     gift_order.is_selected = this.is_select_all;
    //   });
    // },
    // async deleteAll() {
    //   this.isDeleteAll = true;
    //   let deleteallIds = [];
    //   this.place_orders.forEach((gift_order) => {
    //     if (gift_order.is_selected) deleteallIds.push(gift_order);
    //   });
    //   await axios
    //     .post("/place_orders/alldelete", { deleteallIds })
    //     .then(() => {
    //       this.filter.status = "";
    //       this.getData();
    //     })
    //     .catch(function (error) {
    //       this.getData();
    //       console.log(error);
    //     });
    //   // let response = await axios.post(/sync_users/update_date_all, this.form);
    //   this.isDeleteAll = false;
    // },
    formatDate(date) {
      return date ? moment(date).format("YYYY-MM-DD") : "";
    },

    formatTrackingDate(dateString) {
      if (!dateString) return '';

      try {
        const date = new Date(dateString);
        return date.toLocaleString('en-IN', {
          year: 'numeric',
          month: 'short',
          day: 'numeric',
          hour: '2-digit',
          minute: '2-digit'
        });
      } catch (error) {
        return dateString;
      }
    },
    formatAddress(address, city, state, pincode, country) {
      const parts = [address, city, state, pincode, country]
        .map(part => part != null ? String(part).trim() : '')
        .filter(part => part !== '');
      return parts.length > 0 ? parts.join(', ') : 'N/A';
    },
    async generateExcel() {
      this.isExcelLoading = true;
      this.filter.search_keyword = this.filter.search_keyword
        ? this.filter.search_keyword
        : "";
      this.filter.show_deleted = this.$route.query.open_trash ? 1 : 0;
      this.filter.is_active = this.filter.is_active
        ? this.filter.is_active
        : "";
      this.filter.product_id = this.filter.product_id
        ? this.filter.product_id
        : "";
      this.filter.status = this.filter.status ? this.filter.status : "";
      this.filter.user_id = this.filter.user_id ? this.filter.user_id : "";
      this.filter.state = this.filter.state ? this.filter.state : "";
      this.filter.vehicle_maker = this.filter.vehicle_maker
        ? this.filter.vehicle_maker
        : "";
      this.filter.city = this.filter.city ? this.filter.city : "";
      this.filter.position_id = this.filter.position_id
        ? this.filter.position_id
        : "";
      this.filter.month_year = this.filter.month_year
        ? this.filter.month_year
        : "";
      this.filter.start_date = this.filter.start_date
        ? this.filter.start_date
        : "";
      this.filter.end_date = this.filter.end_date ? this.filter.end_date : "";
      if (this.$route.query.store_id != null) {
        this.filter.store_id = this.decryptIt(this.$route.query.store_id);
      } else {
        this.filter.store_id = "";
      }
      let response = [];
      let query =
        "&role_id=2" +
        "&companyId=" +
        this.company.id +
        "&is_active=" +
        this.filter.is_active +
        "&product_id=" +
        this.filter.product_id +
        "&user_id=" +
        this.filter.user_id +
        "&store_id=" +
        this.filter.store_id +
        "&position_id=" +
        this.filter.position_id +
        "&state=" +
        this.filter.state +
        "&vehicle_maker=" +
        this.filter.vehicle_maker +
        "&city=" +
        this.filter.city +
        "&start_date=" +
        this.filter.start_date +
        "&status=" +
        this.filter.status +
        "&end_date=" +
        this.filter.end_date +
        "&month_year=" +
        this.filter.month_year +
        "&search_keyword=" +
        this.filter.search_keyword;
      response = await axios
        .get(`/place_orders/excel_export?${query}`)
        .then((response) => window.open(`${response.data.data}`, "_blank"));
      if (response) {
        console.log(response);
      }
      this.isExcelloading = false;
    },
    navigateToCreateShipment(giftOrder) {
      // Navigate to dedicated shipment creation page with only gift order ID
      this.$router.push({
        path: '/shipments/create',
        query: {
          giftOrderId: giftOrder.id
        }
      });
    },
    
    async openViewShipmentDialog(giftOrder) {
      try {
        this.selectedGiftOrder = giftOrder;
        this.viewShipmentDialog = true;
        this.trackingData = null;
        this.trackingError = null;
        this.liveTrackingActive = false;

        // Load shipment data if available (giftOrder.delivery is an object)
        if (giftOrder.delivery && typeof giftOrder.delivery === 'object') {
          this.viewShipmentForm = { ...giftOrder.delivery };

          // Fetch tracking information if waybill exists
          if (giftOrder.delivery.waybill) {
            await this.fetchTrackingData(giftOrder.delivery.waybill);
          }

          // Subscribe to real-time tracking updates via WebSocket
          if (giftOrder.delivery.id && this.$echo) {
            this.$echo.private(`delivery.${giftOrder.delivery.id}`)
              .listen('.ShipmentStatusUpdated', (data) => {
                // Prepend new scan to tracking history
                if (this.trackingData) {
                  const newScan = {
                    ScanDetail: {
                      ScanDateTime: data.status_datetime,
                      Scan: data.status,
                      ScannedLocation: data.status_location,
                      Instructions: '',
                      StatusCode: '',
                      ScanType: 'UD',
                    }
                  };
                  this.trackingData.scans = [newScan, ...(this.trackingData.scans || [])];
                  this.trackingData.status = data.status;
                } else {
                  // No prior tracking data — seed minimal object
                  this.trackingData = {
                    waybill: data.awb,
                    status: data.status,
                    scans: [{
                      ScanDetail: {
                        ScanDateTime: data.status_datetime,
                        Scan: data.status,
                        ScannedLocation: data.status_location,
                        Instructions: '',
                        StatusCode: '',
                        ScanType: 'UD',
                      }
                    }],
                    currentStatus: null,
                  };
                }
                this.$toast.info(`Shipment update: ${data.status}`);
              });
            this.liveTrackingActive = true;
          }
        } else {
          this.trackingError = 'No shipment data available';
        }

      } catch (error) {
        console.error('Error opening view shipment dialog:', error);
        this.$toast.error('Failed to load shipment details.');
      }
    },

    async refreshTrackingData() {
      if (this.viewShipmentForm.waybill) {
        await this.fetchTrackingData(this.viewShipmentForm.waybill);
      }
    },

    getTrackingHistory() {
      // If we have tracking data, use it to build the timeline
      let actualScans = [];
      
      if (this.trackingData && this.trackingData.scans) {
        actualScans = this.trackingData.scans.map(scan => {
          const scanDetail = scan.ScanDetail;
          return {
            date: scanDetail.ScanDateTime,
            status: scanDetail.Scan,
            location: scanDetail.ScannedLocation,
            remarks: scanDetail.Instructions,
            statusCode: scanDetail.StatusCode,
            scanType: scanDetail.ScanType,
            isActual: true
          };
        });

        // Add current status if available and not duplicate
        if (this.trackingData.currentStatus) {
          const currentStatus = this.trackingData.currentStatus;
          const isDuplicate = actualScans.some(scan => 
            scan.statusCode === currentStatus.StatusCode && 
            scan.date === currentStatus.StatusDateTime
          );
          
          if (!isDuplicate) {
            actualScans.push({
              date: currentStatus.StatusDateTime,
              status: currentStatus.Status,
              location: currentStatus.StatusLocation,
              remarks: currentStatus.Instructions,
              statusCode: currentStatus.StatusCode,
              scanType: currentStatus.StatusType,
              isActual: true
            });
          }
        }
      }

      // Create complete expected timeline with actual data merged
      const completeTimeline = this.createCompleteTimeline(actualScans);
      
      // Sort by expected order (Ready to Ship → Delivered)
      return completeTimeline;
    },

    createCompleteTimeline(actualScans) {
      // Check if any scan indicates cancellation
      const hasCancellationScan = actualScans.some(scan => {
        const statusCode = scan.statusCode;
        const scanText = scan.status ? scan.status.toLowerCase() : '';
        const instructions = scan.remarks ? scan.remarks.toLowerCase() : '';
        
        return statusCode === 'DTUP-210' || 
               statusCode === 'X-PNP' || 
               scanText.includes('not picked') || 
               scanText.includes('cancelled') ||
               instructions.includes('seller cancelled') ||
               instructions.includes('order cancelled');
      });
      
      // If cancelled, return simplified cancelled timeline
      if (hasCancellationScan) {
        const cancelledScan = actualScans.find(scan => {
          const statusCode = scan.statusCode;
          const scanText = scan.status ? scan.status.toLowerCase() : '';
          const instructions = scan.remarks ? scan.remarks.toLowerCase() : '';
          
          return statusCode === 'DTUP-210' || 
                 scanText.includes('not picked') || 
                 scanText.includes('cancelled') ||
                 instructions.includes('seller cancelled') ||
                 instructions.includes('order cancelled');
        });
        
        const readyToShipScan = actualScans.find(scan => scan.statusCode === 'X-UCI');
        
        return [
          {
            status: 'Ready To Ship',
            icon: 'mdi-package-variant',
            color: '#2196F3',
            isCompleted: true,
            date: readyToShipScan ? readyToShipScan.date : null,
            location: readyToShipScan ? readyToShipScan.location : null,
            remarks: readyToShipScan ? readyToShipScan.remarks : 'Manifest uploaded',
            order: 1
          },
          {
            status: 'Order Cancelled',
            icon: 'mdi-close-circle',
            color: '#F44336',
            isCompleted: true,
            date: cancelledScan ? cancelledScan.date : null,
            location: cancelledScan ? cancelledScan.location : null,
            remarks: cancelledScan ? cancelledScan.remarks : 'Order has been cancelled',
            order: 2
          }
        ];
      }
      
      // Define the expected tracking flow - matching official Delhivery design
      const expectedFlow = [
        {
          status: 'Ready to Ship',
          statusCode: ['X-UCI'], // Manifested maps to Ready to Ship in official design
          description: 'Shipment ready for pickup',
          icon: 'mdi-package-variant',
          color: '#2196F3',
          order: 1
        },
        {
          status: 'Scheduled for Pickup',
          statusCode: ['X-SFP', 'X-PPOM'], // X-PPOM = Shipment picked up
          description: '',
          icon: 'mdi-truck-outline',
          color: '#2196F3',
          order: 2
        },
        {
          status: 'In-transit',
          statusCode: ['X-PKU', 'X-INT', 'X-PIOM', 'X-DBL1F', 'X-DLL2F', 'X-ILL2F', 'X-ILL1F', 'X-IBD3F'],
          description: '',
          icon: 'mdi-truck',
          color: '#2196F3',
          order: 3
        },
        {
          status: 'Out for delivery',
          statusCode: ['X-OFD'],
          description: '',
          icon: 'mdi-truck-fast',
          color: '#FF9800',
          order: 4
        },
        {
          status: 'Delivered',
          statusCode: ['X-DLV'],
          description: '',
          icon: 'mdi-check-circle',
          color: '#4CAF50',
          order: 5
        }
      ];

      const timeline = [];
      let currentStage = 0; // Default to stage 0 (no progress)

      // Find the highest stage reached based on actual scans
      actualScans.forEach(scan => {
        expectedFlow.forEach((step) => {
          const statusCodes = Array.isArray(step.statusCode) ? step.statusCode : [step.statusCode];
          if (statusCodes.includes(scan.statusCode)) {
            currentStage = Math.max(currentStage, step.order);
          }
        });
      });

      expectedFlow.forEach((expectedStep) => {
        // Check if this step is completed based on current stage
        const isCompleted = expectedStep.order <= currentStage;

        // Find matching scans for this step
        const statusCodes = Array.isArray(expectedStep.statusCode) ? expectedStep.statusCode : [expectedStep.statusCode];
        const matchingScans = actualScans.filter(scan => statusCodes.includes(scan.statusCode));
        // Use LAST matching scan for current/completed steps (shows latest activity like Delhivery portal)
        const actualScan = matchingScans.length > 0 ? matchingScans[matchingScans.length - 1] : null;

        let stepData = {
          status: expectedStep.status,
          icon: expectedStep.icon,
          color: expectedStep.color,
          statusCode: expectedStep.statusCode,
          isCompleted: isCompleted,
          isActual: !!actualScan,
          order: expectedStep.order
        };

        if (actualScan && isCompleted) {
          // This step has actual data and is completed
          stepData = {
            ...stepData,
            date: actualScan.date,
            location: actualScan.location,
            remarks: actualScan.remarks || expectedStep.description,
            scanType: actualScan.scanType
          };
        } else if (expectedStep.status === 'Delivered' && !isCompleted && this.trackingData && this.trackingData.delivery_date) {
          // Show expected delivery date for pending Delivered step
          stepData = {
            ...stepData,
            date: null,
            location: null,
            remarks: 'Estimated date: ' + this.formatTrackingDate(this.trackingData.delivery_date),
            scanType: 'UD'
          };
        } else {
          // Future step or no actual data
          stepData = {
            ...stepData,
            date: null,
            location: null,
            remarks: expectedStep.description || 'Pending',
            scanType: 'UD'
          };
        }

        timeline.push(stepData);
      });

      return timeline;
    },

    getStatusColor(status) {
      if (!status) return 'grey';
      
      const statusLower = status.toLowerCase();
      if (statusLower.includes('delivered')) return 'green';
      if (statusLower.includes('out for delivery')) return 'orange';
      if (statusLower.includes('in-transit') || statusLower.includes('manifested')) return 'blue';
      if (statusLower.includes('pickup') || statusLower.includes('ready')) return 'purple';
      if (statusLower.includes('cancelled') || statusLower.includes('returned')) return 'red';
      
      return 'primary';
    },

    getStatusIcon(status) {
      if (!status) return 'mdi-help-circle';
      
      const statusLower = status.toLowerCase();
      if (statusLower.includes('delivered')) return 'mdi-check-circle';
      if (statusLower.includes('out for delivery')) return 'mdi-truck-delivery';
      if (statusLower.includes('in-transit')) return 'mdi-truck';
      if (statusLower.includes('pickup') || statusLower.includes('ready')) return 'mdi-package-variant';
      if (statusLower.includes('manifested')) return 'mdi-file-document';
      if (statusLower.includes('cancelled') || statusLower.includes('returned')) return 'mdi-close-circle';
      
      return 'mdi-circle';
    },
    
    closeViewShipmentDialog() {
      // Unsubscribe from real-time delivery channel before closing
      if (this.selectedGiftOrder && this.selectedGiftOrder.delivery && this.selectedGiftOrder.delivery.id && this.$echo) {
        this.$echo.leave(`delivery.${this.selectedGiftOrder.delivery.id}`);
      }
      this.liveTrackingActive = false;

      this.viewShipmentDialog = false;
      this.isEditingShipment = false;
      this.selectedGiftOrder = null;
      this.selectedDelivery = null;
      this.originalShipmentData = null;
      // Reset tracking data
      this.trackingData = null;
      this.loadingTrackingData = false;
      this.trackingError = null;
    },

    // Helper methods to check delivery status
    hasDelivery(giftOrder) {
      // Check if delivery exists as an object (based on the API response structure)
      return giftOrder.delivery && typeof giftOrder.delivery === 'object' && Object.keys(giftOrder.delivery).length > 0;
    },

    async fetchTrackingData(waybill) {
      if (!waybill) {
        this.trackingError = 'No waybill number available';
        return;
      }

      try {
        this.loadingTrackingData = true;
        this.trackingError = null;
        
        const response = await axios.get(`/delhivery/track/${waybill}`);
        
        if (response.data.success && response.data.data) {
          this.processTrackingData(response.data.data);
        } else {
          this.trackingError = response.data.message || 'No tracking information found for this shipment';
        }
        
      } catch (error) {
        console.error('Error fetching tracking data:', error);
        this.trackingError = error.response?.data?.message || 'Failed to load tracking information';
      } finally {
        this.loadingTrackingData = false;
      }
    },

    processTrackingData(data) {
      try {
        // Extract data from Delhivery API response format
        const shipmentData = data.ShipmentData?.[0]?.Shipment;
        
        if (!shipmentData) {
          this.trackingError = 'Invalid tracking data format';
          return;
        }

        this.trackingData = {
          waybill: shipmentData.AWB,
          status: shipmentData.Status?.Status || 'Unknown',
          pickup_date: shipmentData.PickUpDate,
          delivery_date: shipmentData.DeliveryDate || shipmentData.ExpectedDeliveryDate,
          origin: shipmentData.Origin,
          destination: shipmentData.Destination,
          scans: shipmentData.Scans || [],
          currentStatus: shipmentData.Status,
          consignee: shipmentData.Consignee,
          invoiceAmount: shipmentData.InvoiceAmount,
          quantity: shipmentData.Quantity,
          orderType: shipmentData.OrderType,
          referenceNo: shipmentData.ReferenceNo
        };

      } catch (error) {
        console.error('Error processing tracking data:', error);
        this.trackingError = 'Failed to process tracking information';
      }
    },

    // Check if shipment can be cancelled
    canCancelShipment(giftOrder) {
      if (!giftOrder.delivery || !giftOrder.delivery.waybill) {
        return false;
      }
      
      // Can't cancel if gift order is already cancelled (status 6)
      if (giftOrder.status === 6) {
        return false;
      }
      
      // Can only cancel if delivery status is not delivered, cancelled, or returned
      const status = giftOrder.delivery.status || '';
      const nonCancellableStatuses = ['delivered', 'cancelled', 'returned', 'out for delivery'];
      return !nonCancellableStatuses.some(s => status.toLowerCase().includes(s));
    },

    // Confirm cancellation before proceeding
    confirmCancelShipment(giftOrder) {
      this.selectedGiftOrderForCancel = giftOrder;
      this.cancelShipmentDialog = true;
    },

    // Cancel shipment API call
    async cancelShipment() {
      if (!this.selectedGiftOrderForCancel || !this.selectedGiftOrderForCancel.delivery) {
        this.$toast.error('Invalid shipment data');
        return;
      }

      try {
        this.cancellingShipment = this.selectedGiftOrderForCancel.id;

        const response = await axios.post('/deliveries/cancel', {
          delivery_id: this.selectedGiftOrderForCancel.delivery.id,
          waybill: this.selectedGiftOrderForCancel.delivery.waybill,
          gift_order_id: this.selectedGiftOrderForCancel.id
        });

        if (response.data.success) {
          this.$toast.success('Shipment cancelled successfully');
          
          // Update the local data to reflect cancellation
          const orderIndex = this.place_orders.findIndex(o => o.id === this.selectedGiftOrderForCancel.id);
          if (orderIndex !== -1) {
            this.place_orders[orderIndex].delivery.status = 'Cancelled';
            this.place_orders[orderIndex].status = 6; // Set gift order status to 6 (Order Cancelled)
          }
          
          this.cancelShipmentDialog = false;
          this.selectedGiftOrderForCancel = null;
        } else {
          this.$toast.error(response.data.message || 'Failed to cancel shipment');
        }

      } catch (error) {
        console.error('Error cancelling shipment:', error);
        
        let errorMessage = 'Failed to cancel shipment';
        if (error.response && error.response.data) {
          errorMessage = error.response.data.message || errorMessage;
        }
        
        this.$toast.error(errorMessage);
      } finally {
        this.cancellingShipment = null;
      }
    },

    async downloadShippingLabel(giftOrder) {
      if (!giftOrder || !giftOrder.delivery || !giftOrder.delivery.waybill) {
        this.$toast.error('Waybill number not available');
        return;
      }

      try {
        this.downloadingLabel = giftOrder.id;

        // Get PDF download link from backend API
        const response = await axios.post('/deliveries/generate-shipping-label', {
          waybill: giftOrder.delivery.waybill,
          pdf_size: 'A4' // A4 size for standard printing
        });

        if (response.data.success && response.data.data && response.data.data.pdf_download_link) {
          const pdfLink = response.data.data.pdf_download_link;

          // Build filename: FIRSTNAME_LASTNAME_WAYBILL.pdf
          const user = giftOrder.user;
          const namePart = user
            ? [user.first_name, user.last_name].filter(Boolean).join('_').toUpperCase().replace(/\s+/g, '_')
            : 'UNKNOWN';
          const fileName = `${namePart}_${giftOrder.delivery.waybill}.pdf`;

          // Try backend proxy (custom filename, no CORS); fall back to direct tab if not deployed
          try {
            const proxyResponse = await axios.post('/deliveries/download-shipping-label', {
              waybill: giftOrder.delivery.waybill,
              filename: fileName,
              pdf_size: 'A4',
            }, { responseType: 'blob' });

            const blobUrl = URL.createObjectURL(new Blob([proxyResponse.data], { type: 'application/pdf' }));
            const anchor = document.createElement('a');
            anchor.href = blobUrl;
            anchor.download = fileName;
            document.body.appendChild(anchor);
            anchor.click();
            document.body.removeChild(anchor);
            URL.revokeObjectURL(blobUrl);
            this.$toast.success('Downloaded: ' + fileName);
          } catch (_proxyErr) {
            // Fallback: open in new tab until backend is deployed
            window.open(pdfLink, '_blank');
            this.$toast.success('Shipping label opened in new tab');
          }
        } else {
          throw new Error(response.data.message || 'PDF download link not found');
        }

      } catch (error) {
        console.error('Error downloading shipping label:', error);

        let errorMessage = 'Failed to download shipping label';

        if (error.response && error.response.data) {
          errorMessage = error.response.data.message || errorMessage;
        } else if (error.message) {
          errorMessage = error.message;
        }

        this.$toast.error(errorMessage);
      } finally {
        this.downloadingLabel = null;
      }
    }
  },
};
</script>

<style scoped>
/* Delhivery Timeline Styles */
.delhivery-timeline {
  padding: 16px 0;
}

.delhivery-timeline-item {
  display: flex;
  margin-bottom: 16px;
  position: relative;
}

.delhivery-timeline-item:last-child {
  margin-bottom: 0;
}

.delhivery-timeline-item:last-child .delhivery-timeline-line {
  display: none;
}

.timeline-icon-wrapper {
  position: relative;
  margin-right: 16px;
  display: flex;
  flex-direction: column;
  align-items: center;
  flex-shrink: 0;
  width: 32px;
}

.delhivery-icon-container {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background: #E0E0E0;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2;
  position: relative;
  flex-shrink: 0;
}

.delhivery-timeline-item.completed .delhivery-icon-container {
  background: #2196F3;
}

.delhivery-timeline-line {
  position: absolute;
  top: 32px;
  left: 50%;
  transform: translateX(-50%);
  width: 2px;
  bottom: -16px;
  background: #E0E0E0;
  z-index: 1;
}

.completed-line {
  background: #2196F3;
}

.pending-line {
  background: #E0E0E0;
}

.delhivery-content {
  flex: 1;
  padding-top: 2px;
}

.delhivery-status {
  font-size: 16px;
  font-weight: 400;
  margin: 0 0 4px 0;
  color: #333333;
  line-height: 1.2;
}

.delhivery-timeline-item.completed .delhivery-status {
  color: #2196F3;
  font-weight: 500;
}

.delhivery-meta {
  margin: 0;
}

.delhivery-date {
  font-size: 12px;
  color: #666666;
  font-weight: 400;
  display: block;
  margin-bottom: 2px;
}

.delhivery-description {
  font-size: 12px;
  color: #2196F3;
  margin: 2px 0;
  cursor: pointer;
  text-decoration: none;
  font-weight: 400;
}

.delhivery-location {
  font-size: 12px;
  color: #666666;
  margin: 2px 0 0 0;
  font-weight: 400;
}

/* Responsive design */
@media (max-width: 600px) {
  .timeline-header {
    flex-direction: column;
    align-items: flex-start;
  }

  .timeline-date {
    margin-left: 0;
    margin-top: 4px;
  }
}

/* Delivery Details Styles */
.detail-item {
  display: flex;
  flex-direction: column;
  padding: 8px 0;
  border-bottom: 1px solid #f0f0f0;
}

.detail-item:last-child {
  border-bottom: none;
}

.detail-item.waybill-highlight {
  background: #e3f2fd;
  padding: 12px;
  border-radius: 8px;
  margin-bottom: 8px;
  border-bottom: none;
}

.detail-item.waybill-highlight .detail-value {
  font-size: 18px;
  letter-spacing: 1px;
}

.detail-item.shipping-charge-highlight {
  background: linear-gradient(135deg, #e8f5e9 0%, #f1f8e9 100%);
  padding: 12px;
  border-radius: 8px;
  border: 1px solid #c8e6c9;
  margin-top: 8px;
}

.detail-item.shipping-charge-highlight .detail-value {
  font-size: 18px;
}

.details-card {
  height: 100%;
  margin-bottom: 16px;
}

.details-card .v-card__title {
  font-size: 16px;
  border-bottom: 1px solid #f0f0f0;
}

.detail-label {
  font-size: 11px;
  color: #757575;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  margin-bottom: 4px;
  font-weight: 500;
}

.detail-value {
  font-size: 14px;
  color: #333;
  font-weight: 400;
  word-break: break-word;
}

.v-expansion-panel {
  margin-bottom: 8px;
  border: 1px solid #e0e0e0;
  border-radius: 8px !important;
}

.v-expansion-panel::before {
  box-shadow: none !important;
}

.v-expansion-panel-header {
  min-height: 48px !important;
  padding: 12px 16px;
}

.v-expansion-panel-content__wrap {
  padding: 0 16px 16px;
}

/* Delhivery Wallet Badge Styles */
.delhivery-wallet-badge {
  background: #ffffff;
  border-radius: 24px;
  padding: 8px 16px;
  border: 1px solid #e0e0e0;
  transition: all 0.3s ease;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
}

.delhivery-wallet-badge:hover {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.delhivery-wallet-badge.wallet-sufficient {
  background: linear-gradient(135deg, #ffffff 0%, #f1f8e9 100%);
  border-color: #c8e6c9;
}

.delhivery-wallet-badge.wallet-low {
  background: linear-gradient(135deg, #ffffff 0%, #ffebee 100%);
  border-color: #ffcdd2;
}

.delhivery-wallet-badge.wallet-unknown {
  background: linear-gradient(135deg, #ffffff 0%, #f5f5f5 100%);
  border-color: #e0e0e0;
}

.delhivery-logo {
  width: 24px;
  height: 24px;
  object-fit: contain;
}

.wallet-info {
  line-height: 1.2;
}

.wallet-label {
  font-size: 12px;
  font-weight: 600;
  color: #424242;
  letter-spacing: 0.3px;
}

.wallet-status-chip {
  font-weight: 600;
  letter-spacing: 0.5px;
}

.action-btn {
  opacity: 0.7;
  transition: opacity 0.2s ease;
}

.action-btn:hover {
  opacity: 1;
}

/* Responsive adjustments for wallet badge */
@media (max-width: 768px) {
  .delhivery-wallet-badge {
    margin-top: 12px;
    width: 100%;
    justify-content: center;
  }

  .v-card-title.d-flex.flex-wrap {
    flex-direction: column;
    align-items: flex-start !important;
  }
}
</style>
